import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=4ce01a54&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=4ce01a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce01a54",
  null
  
)

export default component.exports